
import { useResourceUsage } from './use-resource-usage';
import { useSubscriptionData } from './use-subscription-data';
import { useAuth } from '@/contexts/AuthContext';

export const useTradingAccountValidation = () => {
  const { user } = useAuth();
  const { data: subscriptionData } = useSubscriptionData(user?.id);
  const { data: resourceUsage } = useResourceUsage(user?.id);

  const canCreateAccount = () => {
    if (!subscriptionData?.package || !resourceUsage) {
      return false;
    }

    return resourceUsage.tradingAccountsCount < subscriptionData.package.max_trading_accounts;
  };

  const getErrorMessage = () => {
    if (!subscriptionData?.package) {
      return 'No active subscription found. Please upgrade to connect trading accounts.';
    }

    if (resourceUsage && resourceUsage.tradingAccountsCount >= subscriptionData.package.max_trading_accounts) {
      return `You've reached your limit of ${subscriptionData.package.max_trading_accounts} trading accounts. Please upgrade your subscription to add more accounts.`;
    }

    return null;
  };

  return {
    canCreateAccount,
    getErrorMessage,
    currentCount: resourceUsage?.tradingAccountsCount || 0,
    maxAccounts: subscriptionData?.package?.max_trading_accounts || 0
  };
};
